import React from 'react';

export const IconChevronRight = () => (
    <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3L19 19L3 35" stroke="#8C9970" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export const IconChevronLeft = () => (
    <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3L3 19L19 35" stroke="#8C9970" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
